import { BiometryType } from '@capgo/capacitor-native-biometric';
import {
  IonIcon,
  IonText,
} from '@ionic/react';
import { closeOutline } from 'ionicons/icons';

import FaceIdLogo from '@/assets/icons/face-id-black.svg';
import FingerprintLogo from '@/assets/icons/fingerprint-black.svg';
import Button from '@/components/common/Button';

import styles from './SetupBiometryModal.module.scss';

export interface SetupBiometryModalProps {
  biometryType: BiometryType;
  onDismiss: (configure: boolean) => void;
}

export default function SetupBiometryModal({
  biometryType,
  onDismiss,
}: SetupBiometryModalProps) {
  const confirmBiometry = () => onDismiss(true);
  const rejectBiometry = () => onDismiss(false);

  return (
    <div id="bottom-modal-setup-biometry" className={styles.container}>
      <div className={styles.closeButton}>
        <IonIcon
          id="button-close-setup-biometry-modal"
          icon={closeOutline}
          onClick={rejectBiometry}
        />
      </div>
      <div className={styles.infoContainer}>
        <IonIcon
          src={biometryType === BiometryType.FACE_ID ? FaceIdLogo : FingerprintLogo}
          className={styles.biometryLogo}
        />
        <div>
          <IonText color="dark">
            <h3>Inicia sesión más rápido</h3>
          </IonText>
          <IonText color="medium">
            <p>
              {biometryType === BiometryType.FACE_ID
                ? 'Configura tu acceso con Face ID y accede a la App Pepper Comercios más rápido que nunca.'
                : 'Configura tu acceso biométrico y accede a la App Pepper Comercios más rápido que nunca.'}
            </p>
          </IonText>
        </div>
        <div className={styles.buttons}>
          <Button
            id="button-setup-biometry-modal-confirm"
            onClick={confirmBiometry}
          >
            Confirma
          </Button>
          <Button
            id="button-setup-biometry-modal-reject"
            fill="clear"
            onClick={rejectBiometry}
            className={styles.rejectButton}
          >
            Quizá más tarde
          </Button>
        </div>
      </div>
    </div>
  );
}
